module.exports = __webpack_public_path__ + "img/Flag_of_Brunei.19a741e2.svg";